import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { transparentize } from '@chakra-ui/theme-tools';
import Heading from './heading.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['card', 'header', 'body', 'footer', 'imageWrapStyles', 'image'];
var defaultP = {
  base: 4,
  md: 6
};
var baseStyle = function baseStyle(props) {
  var c = props.colorScheme,
    theme = props.theme;
  return {
    card: {
      py: defaultP,
      pr: defaultP,
      pl: 4,
      border: '1px',
      borderColor: "".concat(c, ".400"),
      bg: transparentize("".concat(c, ".400"), 0.2)(theme),
      borderRadius: 'base',
      boxShadow: 'sm'
    },
    header: _objectSpread(_objectSpread({}, Heading.baseStyle), Heading.sizes.h2),
    body: {
      textStyle: 'text'
    },
    footer: {
      pt: 2
    },
    image: {}
  };
};
var defaultProps = {
  colorScheme: 'yellow'
};
var HighlightCard = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { HighlightCard as default };